"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncAdvancedMenus;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var AdvancedMenus = (0, _Loadable.default)({
  loader: function loader() {
    return import('./AdvancedMenus'
    /* webpackChunkName: "chunk-advanced-menus" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAdvancedMenus(props) {
  return _react.default.createElement(AdvancedMenus, props);
}

module.exports = exports.default;